<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-form
                        ref="reportNearIncidentForm"
                >
                    <h3 class="mb-3">{{$vuetify.lang.t('$vuetify.oeps_report.title')}}</h3>
                    <v-select
                            v-if="appSettings.nearIncidentReportUsesStopCards"
                            v-model="oeps_report_theme_stopcard"
                            :items="scd"
                            item-value="value"
                            item-text="display_value"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.stop_card')"
                            :disabled="formDisabled"
                    ></v-select>
                    <div v-if="appSettings.nearIncidentReportUsesSiteLocations">
                    <v-select
                            v-model="selected_oeps_site_location_data"
                            :items="sld"
                            item-text="name"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.location')"
                            return-object
                            @change="departmentCheck"
                            :disabled="formDisabled"
                    ></v-select>
                    <v-select
                            v-if="departments_for_list"
                            v-model="oeps_report_site_location_department"
                            :items="departments_for_list"
                            item-value="name"
                            item-text="name"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.department')"
                            :disabled="formDisabled"
                    ></v-select>
                    </div>
                    <v-text-field
                            v-model="oeps_machine"
                            :counter="oepsMachineMaxLength"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.machine')"
                            required
                            :disabled="formDisabled"
                            :rules="machineRules"
                    ></v-text-field>
                    <v-checkbox v-model="who_external" 
                    :label="$vuetify.lang.t('$vuetify.oeps_report.external_employee')"
                    @change="whoExternalChanged"
                    :disabled="formDisabled"
                    >
                    </v-checkbox>
                    <v-text-field
                            v-model="oeps_who"
                            :counter="oepsWhoMaxLength"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.who')"
                            required
                            :disabled="formDisabled"
                            :rules="whoRules"
                    ></v-text-field>
                    <v-textarea
                            v-model="oeps_what"
                            no-resize
                            rows="4"
                            ref="inputOepsWhat"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.what')"
                            :disabled="formDisabled"
                            :rules="generalInputRules"
                    ></v-textarea>

                    <v-textarea
                            v-model="oeps_how"
                            no-resize
                            rows="4"
                            ref="inputOepsWhat"
                            :label="$vuetify.lang.t('$vuetify.oeps_report.placeholders.how')"
                            :disabled="formDisabled"
                            :rules="generalInputRules"
                            name="oeps_how"
                    ></v-textarea>

                    <div class="text-center text-md-left mt-3">
                        <p>
                        {{$vuetify.lang.t('$vuetify.oeps_report.when_text_label')}}
                        <br/><br/>
                        {{oeps_date}} {{oeps_time}}
                        </p>
                        
                        <dt-picker :current_date="oeps_date" :current_time="oeps_time" @dateTimeConfirmed="updateDateTime" :disabled="formDisabled"></dt-picker>
                    </div>

                    <!-- when ... -->
                    <div class="text-center text-md-left mt-6">
                        <v-btn class="white--text" color="primary" :disabled="isFilled" @click="doLocationCheck">{{$vuetify.lang.t('$vuetify.global.confirmAndSend')}}</v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <crit-err :shown="has_crit_error" :title="$vuetify.lang.t('$vuetify.errors.missing_critical_resource_title')" code="CE-RNI-01" :is_cancelable="true">
                {{$vuetify.lang.t('$vuetify.errors.missing_critical_resource')}}
            </crit-err>
        <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
    </v-container>
</template>

<script>
    import appSettings from "../../../mixins/config/appSettings"
    import CriticalAppErrorComponent from "../global/criticalAppError/CriticalAppErrorComponent"
    import axios from 'axios'
    import { AppBoundDataStorageHelper } from "@/helpers/LocalStorageHelpers/AppBoundDataStorageHelper"
    import {SiteLocationHandler} from '../../../mixins/siteLocations/SiteLocationHandler'
    import {DateTimeHelper} from '../../../helpers/dateTime/DateTimeHelper'
    import DateTimePickerComponent from '../global/dateTimePicker/DateTimePickerComponent'
    import LMRADataObjectBuilder from "../../../mixins/LMRADataObjectBuilder/LMRADataObjectBuilder";
    import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
    import urlParamsConstructor from '../../../mixins/config/urlParamsConstructor';
    import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

    export const NIR_StopCardStoreKey = 'LAST_NIR_STOPCARD_DATA'
    export const EXTERNALTAG = "[External]"

    export default {
        name: "ReportNearIncidentComponent",
        data : () => {
            return {
                has_crit_error : false,
                formDisabled : false,
                who_external : false,
                oeps_date : '',
                oeps_time : '',
                oeps_machine : '',
                oeps_who : '',
                oeps_how : '',
                oeps_what : '',
                oeps_report_theme_stopcard : null,
                selected_oeps_site_location_data : null,
                departments_for_list : null,
                oeps_report_site_location_name : null,
                oeps_report_site_location_department : null,
                inputMinLength : 4,
                scd : [],
                sld: [],
                whoInputMinLength : 2,
                oepsMachineMaxLength : 200,
                oepsWhoMaxLength : 200,
                oeps_date_time : '',
                showPrivateLocationPopup : false,
            }
        },
        components: {
            critErr: CriticalAppErrorComponent,
            dtPicker : DateTimePickerComponent,
            locationPopup : PrivateLocationCheckComponent
        },
        methods : {
             doLocationCheck(){
                this.showPrivateLocationPopup = true;
            },
            async save(){
                this.formDisabled = true;
                this.showPrivateLocationPopup = false;

                let dataObject  = this.buildBaseLMRADataObjectForType("OEPS_REPORT");
                dataObject['data']['oeps_report_when'] = this.oeps_date_time;
                dataObject['data']['oeps_report_who'] = this.oeps_who;
                dataObject['data']['oeps_report_machine'] = this.oeps_machine;
                dataObject['data']['oeps_report_what'] = this.oeps_what;
                dataObject['data']['oeps_report_how'] = this.oeps_how;
                dataObject['data']['oeps_external_employees'] = this.who_external;

                if(this.appSettings.nearIncidentReportUsesStopCards){
                    dataObject['data']['oeps_report_theme_stopcard'] = this.oeps_report_theme_stopcard;
                }
                

                if(this.appSettings.nearIncidentReportUsesSiteLocations){
                    dataObject['data']['oeps_report_site_location_name'] = this.oeps_report_site_location_name;
                    dataObject['data']['oeps_report_site_location_department'] = (this.oeps_report_site_location_department === null)? 'N/A':this.oeps_report_site_location_department;
                }

                /* START SENDING PART */
              let token = 'FAKETOKEN';//await this.$auth.getTokenSilently();

              sendingLmraDataHelper.SendLMRADataToServer(this.constructUrlParams('near-incident'), dataObject, token)
                    .then(res => {
                        let message = this.$vuetify.lang.t('$vuetify.global.post_success');
                        if(res.data.message !== undefined){
                            message = res.data.message;
                        }
                      sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message);
                        this.$router.replace('/');
                    })
                    .catch(err => {
                      sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + err.message);
                        this.formDisabled = false;
                    });
                /* END SENDING PART */
            },
            whoExternalChanged(){
                if(this.who_external){
                    this.oeps_who = EXTERNALTAG+this.oeps_who;
                }else{
                    this.oeps_who = this.oeps_who.replace(EXTERNALTAG,'');
                }
            },
            departmentCheck(){
              //reset location department.
              this.oeps_report_site_location_name = this.selected_oeps_site_location_data.name;
              this.oeps_report_site_location_department = null;

              if(this.selected_oeps_site_location_data.departments !== undefined && this.selected_oeps_site_location_data.departments.length > 0){
                    this.departments_for_list = this.selected_oeps_site_location_data.departments;
                    //console.log(this.selected_oeps_site_location_data.departments);
                }else{
                    this.departments_for_list = null;
                }
            },
            is_valid_stop_card_item(item){
               if(item.value !== undefined && item.display_values !== undefined){
                    return true;
                }
                return false;
            },
            save_stop_card_data(data){
                //console.log('SAVE data ...');
                let raw_data = [];
                if(data !== undefined && Array.isArray(data)){
                    for(const index in data){
                        if(this.is_valid_stop_card_item(data[index])){
                            raw_data.push(data[index]);
                        }
                    }
                }

                if(raw_data.length >= 0){
                    AppBoundDataStorageHelper.storeAppBoundDataForKey(NIR_StopCardStoreKey, raw_data);
                }
            },
            build_stop_card_data(data){
                let data_for_select = this.prepare_localized_stop_card_data(data);
                //console.log(data_for_select);
                //console.log('PASSED');
                if(data_for_select.length <= 0){
                    this.has_crit_error = true;
                }else{
                     this.scd = data_for_select;
                }
            },
            prepare_localized_stop_card_data(data){
                let current_lang = this.$vuetify.lang.current;
                let localized_data = [];
                //console.log('ENTERED LOCAL');
                if(data !== undefined && Array.isArray(data)){
                    for(const index in data){
                        if(this.is_valid_stop_card_item(data[index])){
                            
                            let display_value = data[index].display_values['en'];
                            if(data[index].display_values[current_lang]){
                                display_value = data[index].display_values[current_lang];
                            }
                            localized_data.push({
                                'value' : data[index].value,
                                'display_value': display_value
                            });
                        }
                    }
                }
                return localized_data;
            },
            load_local_stop_card_data(){
                try {
                        let data = AppBoundDataStorageHelper.getAppBoundDataForKey(NIR_StopCardStoreKey);
                        this.build_stop_card_data(data);
                    } catch (error) {
                        this.has_crit_error = true;
                    }
            },
            build_site_location_data(data){
                let siteLocations = SiteLocationHandler.get_valid_site_locations_data(data);
                //TODO IF LOCATION DATA IS AVAILABLE SCAN LOCATIONS IF ONE MATCHES CURRENT LOCATION
                this.sld = siteLocations;
            },
            updateDateTime(data){
                if(data.date !== undefined && data.time !== undefined){
                    this.oeps_date = data.date;
                    this.oeps_time = data.time;
                    this.oeps_date_time = this.oeps_date + ' ' + this.oeps_time;
                }
                
            }
        },
        computed : {
            isFilled : function () {
                if(
                    this.machineFilled
                    && this.whoFilled
                    && this.howFilled
                    && this.whatFilled
                    && this.departmentSelected
                    && this.siteLocationSelected
                    && this.stopCardSelected
                    && !this.formDisabled
                ){
                    return false;
                }else{
                    return true
                }
            },
             stopCardSelected : function (){
                if(!this.appSettings.nearIncidentReportUsesStopCards){
                    return true
                }

                if(this.oeps_report_theme_stopcard !== null){
                    return true;
                }
                return false;
            },
            siteLocationSelected : function(){
                if(!this.appSettings.nearIncidentReportUsesSiteLocations){
                    return true
                }

                if(this.selected_oeps_site_location_data !== null){
                    return true;
                }else{
                    return false;
                }
            },
            departmentSelected: function(){
                if(!this.appSettings.nearIncidentReportUsesSiteLocations){
                    return true
                }
                if(this.departments_for_list === null){
                    return true;
                }
                
                if(this.oeps_report_site_location_department !== null){
                    return true;
                }else{
                    return false;
                }
            },
            machineFilled : function (){
                if(this.oeps_machine.length >= this.inputMinLength
                && this.oeps_machine.length <= this.oepsMachineMaxLength){
                    return true;
                }
                return false;
            },
            whoFilled : function (){
                if(this.oeps_who.length >= this.whoInputMinLength
                    && this.oeps_who.length <= this.oepsWhoMaxLength){
                    return true;
                }
                return false;
            },
            howFilled : function(){
                if(this.oeps_how.length >= this.inputMinLength){
                    return true;
                }
                return false;
            },
            whatFilled : function () {
                if(this.oeps_what.length >= this.inputMinLength){
                    return true;
                }
                return false;
            },
            machineRules (){
                const rules = [];
                if (this.oepsMachineMaxLength) {
                    const rule =
                        v => (v || '').length <= this.oepsMachineMaxLength ||
                            `A maximum of ${this.oepsMachineMaxLength} characters is allowed`

                    rules.push(rule)
                }
                const  min_length_rule  = this.minLengthRule
                rules.push(min_length_rule)
                return rules
            },
            whoRules (){
                const rules = [];
                if (this.oepsWhoMaxLength) {
                    const rule =
                        v => (v || '').length <= this.oepsWhoMaxLength ||
                            `A maximum of ${this.oepsWhoMaxLength} characters is allowed`

                    rules.push(rule)
                }
                const  min_length_rule  = this.minLengthWhoRule
                rules.push(min_length_rule)
                return rules
            },
            generalInputRules(){
                const rules = [];
                const  min_length_rule  = this.minLengthRule
                rules.push(min_length_rule)
                return rules
            },
            minLengthRule(){
                return v => (v || '').length >= this.inputMinLength || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
            },
            minLengthWhoRule(){
                return v => (v || '').length >= this.whoInputMinLength || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
            }
        },
        mixins : [appSettings,LMRADataObjectBuilder,urlParamsConstructor],
        created() {
            this.oeps_date = DateTimeHelper.getCurrentDate();
            this.oeps_time = DateTimeHelper.getCurrentTime();
            this.oeps_date_time = this.oeps_date + ' ' + this.oeps_time;
            /*let folder = this.appSettings.assetsFolder.toString();
            //window.console.log(folder);
            try{
            let stop_card_data = require("../../../../resources/static_data_sources/json_files/"+folder+"/stop_card_themes.json");
            this.prepare_stop_cards(stop_card_data);
            //window.console.log(this.scd);
            }catch (e){
                //window.console.log('critical error');
                this.has_crit_error = true;
            }*/
        },
        mounted () {
            axios
            .get('resources/static_data/stop_card_themes.json')
                .then( response => {
                    this.build_stop_card_data(response.data);
                    this.save_stop_card_data(response.data);
                })
                .catch(() => {
                    this.load_local_stop_card_data();
                })
            

            axios
            .get('resources/static_data/static_site_locations.json')
            .then(
                response => {
                    this.build_site_location_data(response.data);
                    SiteLocationHandler.save_site_location_data(response.data);
            }).catch(()=>{
                try {
                    let data = SiteLocationHandler.load_site_location_from_storage();
                    this.build_site_location_data(data);
                } catch (error) {
                    window.console.log('error sitelocation' + error);
                }
            });
        }
    }
</script>